import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import * as globals from '@reusable/services/globals';

@Injectable()
export class CatalogsCustomerService {
  responseData: any;
  handleError: any;
  constructor(private router: Router, private httpClient: HttpClient, private gtn: globals.GetTokenNow) { }
  listBrands(queries?) {
    const headers = this.gtn.getHeaders();
    headers['params'] = queries;
    return this.httpClient.get(`${globals.domain}/core/cp/catalogs/`, headers).pipe(map(res => res as any));
  }

  searchByVinOrFrame(body, queries?) {
    const headers = this.gtn.getHeaders();
    headers['params'] = queries;
    return this.httpClient.post(`${globals.domain}/core/cp/vin/`, body, headers).pipe(map(res => res as any));
  }
  searchByVinForCustomerForm(vinNumber) {
    const headers = this.gtn.getHeaders();
    return this.httpClient.get(`${globals.domain}/core/catalog-parts/get-car-by-vin-number/?vinNumber=${vinNumber}`, headers)
      .pipe(map(res => res as any));
  }

  searchByPartID(body, queries?) {
    const headers = this.gtn.getHeaders();
    headers['params'] = queries;
    return this.httpClient.get(`${globals.domain}/customer/catalogue-parts/${body.id}/view/`, headers).pipe(map(res => res as any));
  }
}